import React from "react";
import { ThousandFormatter, useAppSelector } from "@hypexone/uicore";
import Background1 from "../../../../assets/images/marketPage/download (5).png"
import Background2 from "../../../../assets/images/marketPage/lay-odds.png";
interface MarketTableHeadingProps {
  cashOutButton?: JSX.Element;
  title1: string;
  title2: string;
  minStake: number;
  maxStake: number;
  hideLay?: boolean;
}

const MarketTableHeading: React.FC<MarketTableHeadingProps> = ({
  cashOutButton,
  title1,
  title2,
  minStake,
  maxStake,
  hideLay = false,
}) => {
  const minMax = `${ThousandFormatter(minStake)}-${ThousandFormatter(
    maxStake
  )}`;
  const { langData } = useAppSelector((state) => state.cms);
  const backColumnClass = hideLay
    ? "w-[40%] md:w-[10%]"
    : "w-[20%] md:w-[10%]";

  return (
    <thead>
      <tr className="border-b border-b-gray13 h-[25px]">
        {/* Only for mobile */}
        <MinMaxTableHeading
          cashOutButton={cashOutButton}
          minMax={minMax}
          customClassName="w-[60%] md:hidden bg-blue17"
        />

        <th className="md:w-[40%] hidden md:table-cell">
          {cashOutButton ? cashOutButton : null}
        </th>
        <th className="md:w-[10%] hidden md:table-cell" />
        <th className="md:w-[10%] hidden md:table-cell" />
        <th className={backColumnClass}>
          <div className="h-full md:block hidden" style={{
            backgroundImage: `url(${Background1})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}>
            {langData?.[title1]}
          </div>
          <div className="h-full md:hidden block">
            {langData?.[title1]}
          </div>
        </th>

        {!hideLay ? (
          <th className="w-[20%] md:w-[10%]">
            <div className="h-full md:block hidden" style={{
              backgroundImage: `url(${Background2})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}>
              {langData?.[title2]}
            </div>
            <div className="h-full md:hidden block">
              {langData?.[title2]}
            </div>
          </th>
        ) : null}


        {/* Only for web */}
        <MinMaxTableHeading minMax={minMax} customColSpan={2} />
      </tr>
    </thead>
  );
};

export default MarketTableHeading;

const MinMaxTableHeading: React.FC<{
  cashOutButton?: JSX.Element;
  minMax: string;
  customClassName?: string;
  customColSpan?: number;
}> = ({ cashOutButton, customClassName, minMax, customColSpan }) => {
  return (
    <th
      className={customClassName || "w-[20%] bg-blue17 hidden md:table-cell"}
      colSpan={customColSpan || 1}
    >
      {cashOutButton ? cashOutButton : null}
      <span className="text-blue18 text-[8px]">Min/Max</span>{" "}
      <span className="text-[9px]">{minMax}</span>
    </th>
  );
};
